export const getNewPaymentFormStepErrorMessage = (i18n, error, field) => {
  if (!error) return null;

  if (field && Array.isArray(error.details)) {
    const fieldError = error.details.find((item) => item.field === field || item.field.split('.').pop() === field);

    if (fieldError) {
      const key = `newPaymentForms.validation.${field}.${fieldError.code}`;
      const message = i18n.getMessage(key);

      return message !== key ? message : fieldError.message;
    }
  }

  if (field && error.fields && error.fields[field]) {
    const key = `newPaymentForms.validation.${field}.${error.fields[field].code}`;
    const message = i18n.getMessage(key);

    return message !== key ? message : error.fields[field].message;
  }

  return null;
};
